import {StyleSheet, ViewStyle, View, Image} from 'react-native';
import React, {useState} from 'react';
import {ActionButton, Text, Modal, ImagePicker} from 'ui-kits';
import {spacing} from 'theme/Units';

type propType = Readonly<{
  open: boolean;
  onClose: () => void;
  onSubmit: (value: File) => void;
  style?: ViewStyle;
}>;

export function ImagePickerModal(props: propType) {
  const {onClose, open, style: overrideStyle, onSubmit} = props;
  const [previewModal, setPreviewModal] = useState<boolean>(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  function handleSubmit(file: File) {
    setSelectedFile(file);
    const imageUrl = URL.createObjectURL(file);
    setPreviewUrl(imageUrl);
    setPreviewModal(true); // Open preview modal
  }

  return (
    <>
      {/* Modal to select the image */}
      <Modal
        style={overrideStyle}
        open={open && !previewModal}
        onClose={onClose}>
        <Text style={styles.header} variant="inter20">
          Change Profile Picture
        </Text>
        <ImagePicker
          fileType="image/png, image/jpeg"
          onFileUpload={handleSubmit}>
          <ActionButton
            title="Choose Image"
            leftIcon="gallery"
            style={styles.actionButton}
            variant="primary"
            iconSize={24}
          />
        </ImagePicker>
        <Text style={styles.placeholder} variant="placeholder">
          Supported formats : JPEG, PNG (Max 5MB)
        </Text>
      </Modal>

      {/* Modal to preview the selected image */}
      <Modal
        open={previewModal}
        onClose={() => setPreviewModal(false)}
        style={styles.container}>
        <Text variant="sourcesans16m">Preview Selected Image</Text>
        <View style={styles.actionButtonWrapper}>
          {previewUrl && (
            <Image style={styles.profileImage} source={{uri: previewUrl}} />
          )}
          <ActionButton
            variant="primary"
            title="Upload picture"
            onPress={() => {
              if (selectedFile) {
                onSubmit(selectedFile);
                setPreviewModal(false);
                onClose();
              }
            }}
          />
          <ActionButton
            variant="secondary"
            title="Choose another photo"
            onPress={() => {
              setPreviewModal(false);
            }}
          />
        </View>
      </Modal>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: spacing['4'],
  },
  placeholder: {
    fontSize: 14,
  },
  header: {
    alignSelf: 'flex-start',
    marginBottom: spacing['8'],
  },
  actionButton: {
    width: 310,
    marginHorizontal: spacing['6'],
    marginBottom: spacing['2'],
  },
  actionButtonWrapper: {
    width: 300,
    gap: spacing['2'],
  },
  profileImage: {
    borderRadius: 999,
    width: 150,
    height: 150,
    alignSelf: 'center',
    marginBottom: spacing['3'],
  },
});
